import React from "react";

/**
 * Hero-only background layer:
 *  - Animated gradient mesh (3 drifting blobs in brand colors)
 *  - Chalkboard play-diagram SVG pattern (X, O, arrows) at low opacity
 *  Both respect prefers-reduced-motion.
 */
export function HeroBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Animated gradient mesh */}
      <div className="hero-blob hero-blob-1" />
      <div className="hero-blob hero-blob-2" />
      <div className="hero-blob hero-blob-3" />

      {/* Chalkboard play-diagram pattern */}
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.07] text-brand-primary"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern id="pdfplays-chalk" x="0" y="0" width="240" height="180" patternUnits="userSpaceOnUse">
            {/* X marks (offense) */}
            <g stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none">
              <line x1="20" y1="22" x2="34" y2="36" />
              <line x1="34" y1="22" x2="20" y2="36" />

              <line x1="170" y1="120" x2="184" y2="134" />
              <line x1="184" y1="120" x2="170" y2="134" />
            </g>

            {/* O marks (defense) */}
            <g stroke="currentColor" strokeWidth="1.6" fill="none">
              <circle cx="110" cy="40" r="8" />
              <circle cx="60" cy="140" r="8" />
              <circle cx="210" cy="60" r="8" />
            </g>

            {/* Solid arrow route */}
            <g stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round">
              <path d="M 40 70 Q 90 60 130 90" />
              <path d="M 124 83 L 130 90 L 122 92" />
            </g>

            {/* Dashed motion line */}
            <g stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeDasharray="4 6">
              <path d="M 80 150 Q 140 140 200 150" />
            </g>

            {/* Small dot grid accents */}
            <g fill="currentColor">
              <circle cx="14" cy="100" r="1.2" />
              <circle cx="54" cy="100" r="1.2" />
              <circle cx="94" cy="100" r="1.2" />
              <circle cx="200" cy="20" r="1.2" />
              <circle cx="160" cy="170" r="1.2" />
            </g>
          </pattern>
        </defs>
        <rect x="0" y="0" width="100%" height="100%" fill="url(#pdfplays-chalk)" />
      </svg>

      {/* Soft warm fade at the bottom so hero transitions cleanly into content.
          Uses a CSS variable so it follows light/dark mode (see index.css). */}
      <div
        className="absolute inset-x-0 bottom-0 h-24"
        style={{
          backgroundImage:
            "linear-gradient(to bottom, transparent, var(--hero-fade-stop, #FAFAF8))",
        }}
      />
    </div>
  );
}
